import { GlobalState } from "context/GlobalContext";
import { useEffect, useState } from "react";
import parseErrMsgFromError from "utils/errorFunctions/parseErrorMessageFromError";
import { Stack, Typography } from "@mui/material";
import MarimekkoChart from "components/Reports/ReusableComponents/MarimekkoChart/MarimekkoChart";
import { fastapiVmInstance } from "utils/AxiosInstances/RareboxFastApi";
import DounutRelatedCards from "../DounutRelatedCards/DounutRelatedCards";
import DounutChart from "components/Reports/ReusableComponents/DounutChart/DounutChart";
import { dounuts } from "../DounutRelatedCards/data";
import StoreList from "components/Reports/ReusableComponents/StoreList/StoreList";
import { defaultData, sotresData } from "./data";

const StoreListRelatedCards = ({ filter, width=1560, height=700
 }) => {
    const { setSnackBarOpen, setSnackBar, snackbar } = GlobalState();
    const [loading, setLoading] = useState(true);
    const [allStoreData, setAllStoreData] = useState(sotresData);

    const fetch = async () => {
        try {
            setLoading(true);
            const body = { filter };
            console.log('awdfgahijodklajsdh', filter)

            const res = await fastapiVmInstance.post(`/api/summary-report/summary-top-ten-store`, {filter});

            if (res.data.status === "error") throw new Error(res.data?.message);
            const result = res.data.result;
            let allStoreData = []
            sotresData.forEach((store)=>{
                let data = {...store}
                data["stores"] = result[store.key]
                allStoreData.push(data)
            })
            console.log("summary-top-ten-store", allStoreData)
            setAllStoreData(allStoreData || [])
            setLoading(false);
        } catch (error) {
            setSnackBarOpen(true);
            setSnackBar({
                message: parseErrMsgFromError(error),
                severity: "error",
                anchorOrigin: { horizontal: "center", vertical: "top" },
            });
        }
    };


    useEffect(() => {

        fetch();

    }, [filter]);


        return (
            <Stack direction="row" spacing={5} alignItems="center">
                {
                    allStoreData.map((sd)=>(
                        <StoreList name={sd?.name} data={sd?.stores} loading = {loading}/>
                    ))
                }

            </Stack>
        );
};

export default StoreListRelatedCards;
